import { render, staticRenderFns } from "./BadImagesTable.vue?vue&type=template&id=0120dbfe"
import script from "./BadImagesTable.vue?vue&type=script&lang=js"
export * from "./BadImagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports